/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import Tag from "@/src/components/Tag/Tag.tsx";

export default function TagStyleguide() {
  return (
    <>
      <StyleguideView title={"Default"}>
        <Tag label={"Mietmängel"} />
      </StyleguideView>
    </>
  );
};
